const grid = {
  global: {
    columns: 12,
  },
};

export { grid };
